var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconQuestionCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_question-circle",
    "data-name": "Icon / question-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.187,
    height: 13.454,
    viewBox: "0 0 9.187 13.454",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "question-circle",
    d: "M22.451,24.877A1.345,1.345,0,1,0,23.8,26.222,1.345,1.345,0,0,0,22.451,24.877Zm.369-1.153h-.769a.577.577,0,0,1-.577-.577v-.018c0-3.38,3.721-3.057,3.721-5.161,0-.962-.853-1.932-2.76-1.932a3.176,3.176,0,0,0-2.845,1.379.575.575,0,0,1-.781.114l-.631-.44a.576.576,0,0,1-.127-.825,5.042,5.042,0,0,1,4.384-2.15c2.514,0,4.682,1.43,4.682,3.854,0,3.239-3.721,3.068-3.721,5.161v.018A.577.577,0,0,1,22.819,23.724Z",
    transform: "translate(-17.93 -14.114)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconQuestionCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - question-circle.c0099549df2461e062ec472628a754df.svg";